import convertAudioBufferToWav from 'audiobuffer-to-wav';
import { range } from './range';

export { convertAudioBufferToWav };

export const convertBlobToAudioBuffer = async (audioBlob: Blob) => {
  let audioContext: AudioContext | null = null;
  try {
    audioContext = new AudioContext();
    const arrayBuffer = await audioBlob.arrayBuffer();
    return await audioContext.decodeAudioData(arrayBuffer);
  } finally {
    if (audioContext) {
      await audioContext.close().catch(() => {});
    }
  }
};

export const isAudioBufferSilent = (audioBuffer: AudioBuffer): boolean => {
  const silenceThreshold = 0.03;
  return range(audioBuffer.numberOfChannels).every(channelIndex => {
    const samples = audioBuffer.getChannelData(channelIndex);
    return samples.every(sample => Math.abs(sample) <= silenceThreshold);
  });
};
